import React from 'react'

function Search() {
  return (
    <div className=" ">
      Search
    </div>
  );
}

export default Search